export const userInfo = state => state.userInfo
export const allSelect = state => state.allSelect
export const sence = state => state.sence
export const toast = state => state.toast
export const loadingToast = state => state.loadingToast
